import React from 'react';

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.71 6.177c.19-.548.265-.933.265-1.153 0-1.657-1.351-2.966-2.975-2.966s-2.975 1.31-2.975 2.966c0 .22.076.605.265 1.153.182.527.443 1.13.75 1.759.613 1.257 1.375 2.55 1.954 3.426l.006.01.006-.01c.58-.875 1.341-2.169 1.954-3.426.306-.629.568-1.232.75-1.76m-1.787 5.757c1.203-1.82 3.141-5.331 3.141-6.91 0-2.222-1.82-4.024-4.064-4.024-2.245 0-4.064 1.801-4.064 4.024 0 1.579 1.938 5.09 3.14 6.91.45.68 1.398.68 1.847 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.03 11.284c-.52 0-.94.41-.94.914v.83c0 .504.42.914.94.914h9.94c.52 0 .94-.41.94-.915v-.829c0-.505-.42-.914-.94-.914h-1.05c-.302 0-.546-.237-.546-.53 0-.292.244-.528.545-.528h1.05c1.122 0 2.031.883 2.031 1.972v.83c0 1.089-.91 1.972-2.03 1.972h-9.94c-1.12 0-2.03-.883-2.03-1.973v-.829c0-1.09.91-1.973 2.03-1.973h3.587c.3 0 .545.237.545.53 0 .292-.244.529-.545.529z",
    clipRule: "evenodd"
  }));
};
SvgLocation.displayName = "Location";

export { SvgLocation as S };
